// extracted by mini-css-extract-plugin
export default {"header":"hobby-item_header__lKwQD","desc":"hobby-item_desc__FB+7S"};